export default __webpack_public_path__ + "static/media/chandImage.f51e8714.png";